
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import { getTableConfig, inputList } from './config'
import { usePagination } from '@/hooks/usePagination'
import { auditLogAPI, dropdownOfEnterprise } from './api'
import { toResult } from '@/utils/toResult'
import dayjs from 'dayjs'
import detailDialog from './component/detail.vue'

export default defineComponent({
  // name: 'auditLog',
  components: { CSearchList, CTable, detailDialog },
  setup() {
    const remoteData1 = reactive({
      options: [],
      isLoading: false,
      remoteMethod: (val) => {
        dropdownOfEnterprise({ value: val }).then((res) => {
          remoteData1.options = res.data.map((item) => {
            return {
              label: item.value,
              value: item.key,
            }
          })
        })
      },
    })
    const data = reactive({
      inputList: inputList({ ...toRefs(remoteData1) }),
      dataSource: getTableConfig(),
      formData: ref<any>({}),
      currentRow: [],
      isFlag: false,
    })

    const getList = async () => {
      data.dataSource.loading = true
      const p = Object.assign(
        {},
        { ...data.formData },
        {
          currPage: data.dataSource.pagination.currentPage,
          pageSize: data.dataSource.pagination.pageSize,
          startTime:
            data.formData.Time instanceof Array
              ? dayjs(data.formData.Time[0]).format('YYYY-MM-DD HH:mm:00')
              : '',
          endTime:
            data.formData.Time instanceof Array
              ? dayjs(data.formData.Time[1]).format('YYYY-MM-DD HH:mm:00')
              : '',
        }
      )
      p.Time && delete p.Time
      const [err, res] = await toResult(auditLogAPI(p))
      data.dataSource.loading = false
      if (err) return false
      data.dataSource.data = res.list || []
      data.dataSource.pagination.total = res.total
    }

    const handleSearch = (params): void => {
      console.log(params)
      data.formData = Object.assign({}, params)
      getList()
    }

    const handleReset = (params: object): void => {
      data.formData = params
    }

    // c-table pagination method hook
    const { pageCurrentChange, pageSizeChange } = usePagination(
      data.dataSource.pagination,
      () => {
        getList()
      }
    )

    onMounted(() => {
      // 默认展示当前时间回推 1 小时 ~ 次日 0 点
      handleSearch({
        Time: [
          new Date(new Date().getTime() - 3600 * 1000),
          new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000)
        ],
        applicationType: 2,
      })
    })

    const onToggle = (row, name) => {
      data[name] = !data[name]
      row && (data.currentRow = row)
    }

    return {
      ...toRefs(data),
      handleSearch,
      handleReset,
      pageCurrentChange,
      pageSizeChange,
      onToggle,
    }
  },
})
